import React from 'react';

import {Dialogue, Button, Text} from '@albert-io/atomic';

interface Props extends PropsWithClassNameRequired {
  handleClose: () => void;
  invalidEmailDomain: string;
  classroomDomains: string[];
}

const InvalidEmailDomain = ({
  className,
  handleClose,
  invalidEmailDomain,
  classroomDomains
}: Props) => (
  <Dialogue hideCloseBtn className={className} size='m' title='An error occurred'>
    <Dialogue.Body>
      <div className='flex flex-col'>
        <Text className='mb-x3'>
          Your administrator has restricted enrollment in Albert classes so that only students with
          emails in one of these domains can be added:{' '}
          {classroomDomains.map(
            (item, index) => `${item}${index + 1 < classroomDomains.length ? ', ' : ''}`
          )}
          . At least one of the students on the roster you are importing has an email address with
          the domain {invalidEmailDomain} which is not allowed.
        </Text>
      </div>
    </Dialogue.Body>
    <Dialogue.BtnGroup>
      <Button onClick={() => handleClose()}>Dismiss</Button>
    </Dialogue.BtnGroup>
  </Dialogue>
);

export default InvalidEmailDomain;
